import { useState } from "react";
import { useInformationSourceActions } from "./useInformationSourceActions";

type ConfirmActionType = {
  type: "archive" | "restore";
  sourceId: string;
  sourceName: string;
} | null;

export const useConfirmationDialog = (onSuccess: () => void) => {
  const [isOpen, setIsOpen] = useState(false);
  const [confirmAction, setConfirmAction] = useState<ConfirmActionType>(null);
  const [isLoading, setIsLoading] = useState(false);

  const { handleArchive, handleRestore } = useInformationSourceActions();

  const openDialog = (action: NonNullable<ConfirmActionType>) => {
    setConfirmAction(action);
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
    setConfirmAction(null);
  };

  const handleConfirm = async () => {
    if (!confirmAction) return;

    setIsLoading(true);
    try {
      if (confirmAction.type === "archive") {
        await handleArchive(confirmAction.sourceId);
      } else {
        await handleRestore(confirmAction.sourceId);
      }
      closeDialog();
      onSuccess();
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isOpen,
    confirmAction,
    isLoading,
    openDialog,
    closeDialog,
    handleConfirm,
  };
};
